(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5290],{

/***/ 75290:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var ab_text__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(145);
/* harmony import */ var ab_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(276);
/* harmony import */ var _ab_text_photo_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70981);
/* harmony import */ var _ab_text_photo_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_ab_text_photo_scss__WEBPACK_IMPORTED_MODULE_4__);





var TextPhoto = function(param) {
    var image = param.image, imageMobile = param.imageMobile, imagemobile = param.imagemobile, title = param.title, description = param.description, linkText = param.linkText, href = param.href, animated = param.animated, link = param.link;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "ab-text-photo",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                src: (image === null || image === void 0 ? void 0 : image.mediaItemUrl) || image || "/images/404.png",
                alt: title,
                layout: "fill",
                id: "desktop"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                src: (imagemobile === null || imagemobile === void 0 ? void 0 : imagemobile.mediaItemUrl) || imageMobile || "/images/404.png",
                alt: title,
                layout: "fill",
                id: "mobile"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                element: "h2",
                animated: animated,
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                children: description
            }),
            linkText ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_link__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                prefetch: false,
                text: linkText,
                href: href
            }) : null,
            link ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_link__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                prefetch: false,
                text: link.title,
                href: link.url
            }) : null
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (TextPhoto);


/***/ }),

/***/ 70981:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ })

}]);